import React, { useEffect, useRef } from 'react';
import { Button } from '../Button';
import { ClipboardIcon } from '../ClipboardIcon';
import { CopyToClipboard } from '../CopyToClipboard';
import { block } from '../utils/cn';
import './ClipboardButton.css';
const b = block('clipboard-button');
const DEFAULT_ICON_SIZE = 24;
export function ClipboardButton({ text, size = DEFAULT_ICON_SIZE, className, qa, onCopy, }) {
    const buttonRef = useRef(null);
    useEffect(() => {
        var _a;
        (_a = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _a === void 0 ? void 0 : _a.style.setProperty('--yc-button-height', `${size}px`);
    }, [size]);
    return (React.createElement(CopyToClipboard, { text: text, timeout: 1000, onCopy: onCopy }, (status) => (React.createElement(Button, { ref: buttonRef, view: "flat", className: b(null, className), qa: qa },
        React.createElement(Button.Icon, null,
            React.createElement(ClipboardIcon, { status: status, size: size, className: b('icon') }))))));
}
